import { Link, Route, Routes } from 'react-router-dom'
import Home from './Home'
import Tenants from './Tenants'
import Jobs from './Jobs'
import Endpoints from './Endpoints'
import Targets from './Targets'
import Policies from './Policies'
import Schedules from './Schedules'
import Repos from './Repos'
import JobDetail from './JobDetail'
import ThemeSwitchIcon from './ThemeSwitchIcon'
import Settings from './Settings'
import Agents from './Agents'
import { useI18n } from '../i18n'
import MenuDropdown from './MenuDropdown'
import logo from '../assets/radici-logo.svg'
import TenantSelector from './TenantSelector'
import RBACManage from './RBACManage'
import { useEffect, useState } from 'react'
import { apiGet, apiPost } from '../utils/api'
import Health from './Health'
import RestoreWizard from './RestoreWizard'
import Landing from './Landing'
import LanguageToggle from './LanguageToggle'

export default function App() {
  const { t } = useI18n()
  const [me, setMe] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    (async () => {
      try {
        const u = await apiGet('/me')
        setMe(u)
      } catch { /* not logged */ }
      setLoading(false)
    })()
  }, [])

  const login = () => {
    window.location.href = '/auth/login'
  }
  const logout = async () => {
    await apiPost('/auth/logout', {})
    setMe(null)
    window.location.href = '/'
  }

  if (!loading && !me) {
    return <Landing onLogin={login} />
  }

  return (
    <div className="container">
      <header className="flex items-center justify-between py-4">
        <nav className="flex items-center gap-4">
          <Link to="/" className="inline-flex items-center" title="Home">
            <img src={logo} alt="Radici" className="h-8 md:h-10" />
          </Link>
          <MenuDropdown />
        </nav>
        <div className="flex items-center gap-2">
          <TenantSelector />
          <ThemeSwitchIcon />
          <LanguageToggle />
          {loading ? (
            <span>…</span>
          ) : me ? (
            <>
              <span className="mr-3 max-w-[160px] md:max-w-[240px] truncate" title={me.name || me.email}>{t('header.hi')} {me.name || me.email}</span>
              <button className="btn-secondary" onClick={logout}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="mr-2" aria-hidden="true"><path d="M10 17v2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5v2H5v10h5Zm9-5-4-4 1.41-1.41L22.83 12l-6.42 6.41L15 17l4-4h-9v-2h9Z"/></svg>
                {t('buttons.logout')}
              </button>
            </>
          ) : (
            <button className="btn" onClick={login}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="mr-2" aria-hidden="true"><path d="M10 7V5h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9v-2h9V7h-9Zm-1 5 4 4-1.41 1.41L1.17 12l10.42-5.41L13 8l-4 4Z"/></svg>
              {t('buttons.login')}
            </button>
          )}
        </div>
      </header>
      <main className="mt-4">
        <Routes>
          <Route path="/" element={<Home me={me} />} />
          <Route path="/tenants" element={<Tenants />} />
          <Route path="/endpoints" element={<Endpoints />} />
          <Route path="/endpoints/:endpointId/targets" element={<Targets />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/schedules" element={<Schedules />} />
          <Route path="/repos" element={<Repos />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:jobId" element={<JobDetail />} />
          <Route path="/restore" element={<RestoreWizard />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/rbac" element={<RBACManage />} />
          <Route path="/health" element={<Health />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </main>
      <footer className="mt-8 py-6 text-center text-xs text-gray-500 dark:text-gray-400">
        Coded with love by <a className="link" href="https://radici.biz" target="_blank" rel="noreferrer">Radici Soluzioni Informatiche</a> - https://radici.biz
      </footer>
    </div>
  )
}
